import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import Navbar from 'components/Navbar';
import Image from 'components/image/Image';
import DropDown from 'components/Dropdown';
import Button from 'components/Button/Index';
import AboutMeTab from 'components/Tabs/AboutMe/Index';
import { IDropDownItem } from 'core/interface/dropDown';
import { ILanguage } from 'core/interface/language';
import CompenecyPreferencesTab from 'components/Tabs/CompetencyPreferences/Index';
import SkillsTab from 'components/Tabs/Skills/Index';
import ImageAndYoutubeTab from 'components/Tabs/ImageAndYoutube/Index';
import EducationExperienceTab from 'components/Tabs/EducationAndExperience/Index';
import { headerItems } from 'core/constants/header';
import { IHeaderItems } from 'core/interface/headerItems';
import { DashboardTabEnum } from 'core/enum/dashboardTab';
import AvatarPopup from 'components/shared/Popups/Avatar/Index';
import { Popup } from 'components/shared/Popups/Popup/Index';
import useLocales from '../../hooks/useLocales';
import Footer from 'components/Footer/Index';
import { useSelector } from 'react-redux';
import { IMe } from 'core/interface/me';
import FreeUpgradePopup from 'components/shared/Popups/FreeUpgrade/Index';
import Tooltip from 'components/shared/Tooltip/Index';
import TeaserViewPopup from 'components/shared/Popups/TeaserView/Index';
import { ISocialMediaData } from 'core/interface/socialMedia';
import { SwitcherEnum } from 'core/enum/switcherEnum';
import SkeletonLoader from 'components/shared/Skeleton/Index';
import { AccountServce } from 'services/upload/file-upload';
import { CandidateService } from 'services/candidate/candidate';
import DefaultImage from 'components/DefaultImage/Index';
import DownloadPDFPopup from 'components/shared/Popups/DownloadPDF/Index';
import CvSkillsReviewPopup from 'components/shared/Popups/CvSkillsReview/Index';
import Modal from 'components/shared/modal';
import { CvUploadResult } from 'core/interface/cv-skills-review';
import { setRequestError } from '../../redux/slices/errors';
import { store } from '../../redux/store';
import { isValidEmail } from 'utils/isValidEmail';
import { RootState } from '../../redux/store';
import { ShareUrlService } from 'services/shareUrl/shareURL';
import { InvitationsService } from 'services/invitations/invitations';
import Cookies from 'js-cookie';
import { JobService } from 'services/jobs/job';
import ActionButton from 'components/ActionButton/Index';
import { CANDIDATE_ROUTES } from 'core/constants/candidateRoutes';

import './index.scss';
import { Link, useLocation } from 'react-router-dom';

const Dashboard: FC<ILanguage> = (): JSX.Element => {
  const { t } = useLocales();
  const { pathname } = useLocation();
  const { socialMedia } = useSelector((state: RootState) => state.socialMedia);
  const { candidate } = useSelector((state: RootState) => state.candidate);
  const [showAvatarPopup, setShowAvatarPopup] = useState<boolean>(false);
  const [showTeaserPopup, setShowTeaserPopup] = useState<boolean>(false);
  const [showDownload, setShowDownload] = useState<boolean>(false);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [showFreeUpgradePopup, setShowFreeUpgradePopup] =
    useState<boolean>(false);
  const [tabHeader, setTabHeader] = useState<IHeaderItems[]>(headerItems(t));
  const [tabName, setTabName] = useState<string>(DashboardTabEnum.ABOUT_ME);
  const me = useSelector((state: IMe) => state.user).user;
  const uploadFile = useRef<HTMLInputElement>(null);
  const [uploadLoading, setUploadLoading] = useState<boolean>(false);
  const [showCvSkillsPopup, setShowCvSkillsPopup] = useState<boolean>(false);
  const [cvSkillsExtracting, setCvSkillsExtracting] = useState<boolean>(false);
  const [cvUploadSkills, setCvUploadSkills] = useState<CvUploadResult | null>(
    null
  );
  const [openModal, setOpenModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const [inviteEmail, setInviteEmail] = useState<string>('');
  const [inviteEmailError, setInviteEmailError] = useState<string>('');
  const [tooltipProfile, setTooltipProfile] = useState<string>(
    'Share your Recrout profile with this link'
  );
  const dropDownItems: IDropDownItem[] = [
    { value: t('teaser'), to_show: t('teaser') }
  ];

  const [tooltips, setTooltips] = useState({
    hide: false,
    link: false
  });

  const candidates = useSelector(
    (state: RootState) => state.candidates
  ).candidates;

  const { shareURLprofile, shareURLId } = useSelector(
    (state: RootState) => state.profileURL
  );

  const [snack, setSnack] = useState({
    message: '',
    isOpen: false
  });
  const tabPathToEnum = useMemo(
    () => ({
      [CANDIDATE_ROUTES.ABOUT_ME]: DashboardTabEnum.ABOUT_ME,
      [CANDIDATE_ROUTES.TALENT_PROFILE]: DashboardTabEnum.PREFERENCES,
      [CANDIDATE_ROUTES.SKILLS]: DashboardTabEnum.SKILLS,
      [CANDIDATE_ROUTES.CAREER_SCHOOL]: DashboardTabEnum.EDUCATION_EXPERIENCE,
      [CANDIDATE_ROUTES.PERSONAL_BRANDING]: DashboardTabEnum.IMAGE_YOUTUBE
    }),
    []
  );
  const tabEnumToPath = useMemo(
    () => ({
      [DashboardTabEnum.ABOUT_ME]: CANDIDATE_ROUTES.ABOUT_ME,
      [DashboardTabEnum.PREFERENCES]: CANDIDATE_ROUTES.TALENT_PROFILE,
      [DashboardTabEnum.SKILLS]: CANDIDATE_ROUTES.SKILLS,
      [DashboardTabEnum.EDUCATION_EXPERIENCE]: CANDIDATE_ROUTES.CAREER_SCHOOL,
      [DashboardTabEnum.IMAGE_YOUTUBE]: CANDIDATE_ROUTES.PERSONAL_BRANDING
    }),
    []
  );

  const handleInviteInputChange = (e: string): void => {
    setInviteEmail(e);
    if (!isValidEmail(e)) {
      setInviteEmailError(t('Invalid email'));
    } else {
      setInviteEmailError('');
    }
  };

  const getAssesments = async () => {
    try {
      const token = Cookies.get('accesstoken');
      if (!token || !me?.id) {
        return;
      }
      await JobService.getassesments(me.id);
    } catch (err) {
      console.error('Error fetching assessments:', err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getURL();
        await getAssesments();
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    if (me?.id) {
      fetchData();
    }
  }, [me?.id]); // Only depend on me.id, not the entire me object

  const getURL = async () => {
    await ShareUrlService.getShareURL(me.candidate_id);
  };

  const updateCandidate = async (isAnonym: number): Promise<void> => {
    const body = {
      if_seachable: isAnonym === SwitcherEnum.SHOW_ME
    };
    CandidateService.updateCandidate(body, me.candidate_id);
  };

  const handleCloseFreeUpdragePopup = (): void => {
    setShowFreeUpgradePopup(false);
  };

  const handleOpenFreeUpgradePopup = (): void => {
    setShowFreeUpgradePopup(true);
  };

  const handleDropdownChange = (event: string | number): void => {
    if (event === t('teaser')) {
      setShowTeaserPopup(true);
    }
  };

  const handleClosePopup = (): void => {
    setShowAvatarPopup(false);
    setShowTeaserPopup(false);
  };

  const handleOpenPopup = (): void => {
    setShowAvatarPopup(true);
  };

  const getCandidate = async (): Promise<void> => {
    CandidateService.getCandidate(me.candidate_id);
  };

  const updateShareUrl = async (): Promise<void> => {
    if (me.candidate_id && shareURLId) {
      try {
        const response = await ShareUrlService.renewURL(
          me.candidate_id,
          shareURLId
        );
        console.log(response);
      } catch (error) {
        try {
          const resp = await ShareUrlService.getShareURL(me.candidate_id);
          console.log(resp);
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const handleTabChange = (clickedItem: IHeaderItems): void => {
    setTabHeader((prevValues) =>
      prevValues.map((item) =>
        item === clickedItem
          ? { ...item, isActive: true }
          : { ...item, isActive: false }
      )
    );
    if (clickedItem.value) {
      setTabName(clickedItem.value);
      const nextPath = tabEnumToPath[clickedItem.value as DashboardTabEnum];
      if (nextPath && pathname !== nextPath) {
        navigate(nextPath);
      }
    }
  };

  useEffect(() => {
    const activeTabFromPath =
      tabPathToEnum[pathname as keyof typeof tabPathToEnum] ||
      DashboardTabEnum.ABOUT_ME;

    setTabName(activeTabFromPath);
    setTabHeader((prevValues) =>
      prevValues.map((item) => ({
        ...item,
        isActive: item.value === activeTabFromPath
      }))
    );
  }, [pathname, tabPathToEnum]);

  const handleSwitchChange = (e: SwitcherEnum): void => {
    updateCandidate(e);
  };

  const getProfileLink = async (): Promise<void> => {
    // try {
    //   const response = await ShareUrlService.createShareURL(
    //     Number(me?.id)
    //   );
    //   console.log(response);
    // } catch (error) {
    //   console.log(error);
    // }
  };
  const handleCloseCvSkillsPopup = (): void => {
    setShowCvSkillsPopup(false);
    setCvSkillsExtracting(false);
    setCvUploadSkills(null);
  };

  const handleInputChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileInput = e.target as HTMLInputElement;
    if (fileInput.files && fileInput.files.length > 0) {
      const file: File = fileInput.files[0];
      if (me && me.candidate_id) {
        setUploadLoading(true);
        setShowCvSkillsPopup(true);
        setCvSkillsExtracting(true);
        setCvUploadSkills(null);

        const cvFormData = new FormData();
        cvFormData.append('cv', file);
        const result = await AccountServce.uploadCV(
          me.candidate_id,
          cvFormData,
          t
        );

        setUploadLoading(false);
        fileInput.value = '';

        if (result.success && result.hasExtractedSkills) {
          setCvUploadSkills(result);
          setCvSkillsExtracting(false);
        } else {
          handleCloseCvSkillsPopup();
        }
      } else {
        console.error('No file selected');
      }
    }
  };

  const handleCvSkillsSaved = (): void => {
    store.dispatch(setRequestError(t('CV Uploaded'), true));
  };

  const candidateHasCV = !!candidate?.cv;

  const handleViewCv = (): void => {
    if (candidate?.cv) {
      window.open(candidate.cv, '_blank');
    }
  };

  const handleReUploadCv = (): void => {
    uploadFile.current?.click();
  };

  const showSelectedTab = (): JSX.Element | null => {
    if (me) {
      switch (tabName) {
        case DashboardTabEnum.ABOUT_ME:
          return <AboutMeTab t={t} candidate_id={me.candidate_id} />;
        case DashboardTabEnum.PREFERENCES:
          return <CompenecyPreferencesTab t={t} />;
        case DashboardTabEnum.SKILLS:
          return <SkillsTab t={t} candidate_id={me.candidate_id} />;
        case DashboardTabEnum.IMAGE_YOUTUBE:
          return <ImageAndYoutubeTab t={t} />;
        case DashboardTabEnum.EDUCATION_EXPERIENCE:
          return (
            <EducationExperienceTab t={t} candidate_id={me.candidate_id} />
          );

        default:
          return <AboutMeTab t={t} candidate_id={me.candidate_id} />;
      }
    }
    return <></>;
  };

  const handleTooltipVisibility = (tooltipName: string, isShow: boolean) => {
    setTooltips((prevState) => ({
      ...prevState,
      [tooltipName]: isShow
    }));
    // setShowTooltip(isShow);
  };

  const getJobById = (jobId: number | string) => {
    JobService.getJobByIdOrSlug(jobId);
  };

  const handleSendInvitataion = async () => {
    await InvitationsService.setInvitations({
      email: inviteEmail
    });
    setInviteEmail('');
  };

  return (
    <div
      className="dashboardPage"
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Navbar />
      <Modal
        open={openModal}
        onClose={() => setOpenModal(!openModal)}
        className="modal_container"
      >
        <div className="modal_content">
          <div
            className="close_section"
            onClick={() => setOpenModal(!openModal)}
          >
            <Image
              name="close.svg"
              width={20}
              height={20}
              className="close_image"
            />
          </div>
          <div>
            <h1 className="title">{t('Earn your free upgrade!')}</h1>
            <div className="line" />
            <p className="description">
              {t('We value the growth of our community of Young Professionals more than earning lots of money. That is why we have a unique action for our current members: If you help us grow this great talent community by inviting your friends to join, we will reward you with free upgrades of your account.')}
            </p>
            <p className="description">
              {t('Invite only 3 of your friends and you will receive a free three month premium upgrade')}
            </p>
            <p className="description">
              {t('Invite just 6 friends and receive a free six months premium upgrade')}
            </p>
            <p className="description">
              {t('Invite 10 of your friends and you will be rewarder with a free year prescription!')}
            </p>
            <p className="description">
              {t('To earn your free upgrades it does not matter if your friends take a free account or premium account. As soon as they sign up we add the points to your name. It will only cost you a few seconds of\n              investment so start inviting right now!')}
            </p>
          </div>
        </div>
      </Modal>
      <div className="main" style={{ flex: 1 }}>
        <div className="dashboard">
          <div className="dashboard__main">
            <div className="dashboard__left">
              <div className="dashboard__left__image">
                {!me ? (
                  <SkeletonLoader />
                ) : (
                  <>
                    {me && me.avatar ? (
                      <Image
                        className="dashboard__left__image-img"
                        name="profile-image.png"
                        width={236}
                        height={236}
                        url={me?.avatar}
                        objectFit="cover"
                      />
                    ) : (
                      <DefaultImage
                        width={236}
                        height={236}
                        className="dashboard__left__image-img"
                        letter={me.first_name}
                      />
                    )}

                    <ActionButton
                      onClick={handleOpenPopup}
                      className="dashboard__left__action-button"
                    />
                  </>
                )}
              </div>
              <div className="dashboard__left__content">
                <Tooltip
                  className="dashboard__left__hide_show__tool"
                  message="Determine the visibility of your profile"
                  isShow={tooltips.hide}
                />

                <div
                  className="dashboard__left__swiper"
                  onMouseEnter={() => handleTooltipVisibility('hide', true)}
                  onMouseLeave={() => handleTooltipVisibility('hide', false)}
                >
                  <span
                    onClick={() => handleSwitchChange(SwitcherEnum.SHOW_ME)}
                    className={`dashboard__left__swiper-btn ${
                      candidates?.if_seachable ? 'active' : ''
                    }`}
                  >
                    {t('Show me')}
                  </span>
                  <span
                    onClick={() => handleSwitchChange(SwitcherEnum.HIDE_ME)}
                    className={`dashboard__left__swiper-btn ${
                      !candidates?.if_seachable ? 'active' : ''
                    }`}
                  >
                    {t('Hide me')}
                  </span>
                </div>
                <div className="profile-link-container">
                  <span className="profile-link-header">
                    {t('Your profile link')}:
                  </span>
                  <div
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => {
                      setShowTooltip(false);
                      setTooltipProfile('Share your profile with this link');
                    }}
                    className="dashboard__left__link"
                  >
                    <Tooltip
                      className="dashboard__left__link__tool"
                      message={tooltipProfile}
                      isShow={showTooltip}
                    />

                    <input
                      className="dashboard__left__link-input"
                      type="text"
                      readOnly
                      value={shareURLprofile ?? ''}
                      placeholder={t('profile link')}
                      onClick={(e) => {
                        navigator.clipboard.writeText(
                          (e.target as HTMLInputElement).value
                        );
                        setTooltipProfile('Copied !');
                      }}
                    />

                    <span onClick={updateShareUrl}>
                      <Image
                        className="dashboard__left__link-refresh"
                        name="refresh.svg"
                        width={12}
                        height={12}
                      />
                    </span>
                  </div>
                </div>
                <DropDown
                  isReadonly={true}
                  showClose={false}
                  defaultValue="1"
                  dropdownClassName="dashboard__left-dropdown view-drop"
                  items={dropDownItems}
                  selectedValue={handleDropdownChange}
                />

                <div className="dashboard__left__contact">
                  <div className="dashboard__left__contact__user">
                    <div className="dashboard__left__contact__user__icon">
                      <Image
                        className="dashboard__left__contact__user__icon-img"
                        name="email.svg"
                        width={12}
                        height={12}
                      />
                    </div>
                    <a
                      href={`mailto:?subject=Share%20user%20URL&body=Dear%20colleague%0D%0A%0D%0APlease%20review%20this%20candidate%20profile%20and%20let%20me%20know%20what%20you%20think%3F%0D%0A%0D%0A${encodeURIComponent(
                        shareURLprofile ?? ''
                      )}%0D%0A%0D%0AThank%20you!`}
                      target="_blank"
                      rel="noreferrer"
                      className="dashboard__left__contact__user-contact"
                    >
                      {me?.email}
                    </a>
                  </div>
                  {me?.phone && (
                    <div className="dashboard__left__contact__user">
                      <div className="dashboard__left__contact__user__icon">
                        <Image
                          className="dashboard__left__contact__user__icon-img"
                          name="phone.svg"
                          width={12}
                          height={12}
                        />
                      </div>
                      <span className="dashboard__left__contact__user-contact">
                        {me.phone}
                      </span>
                    </div>
                  )}
                  {candidates?.personal_url && (
                    <div className="dashboard__left__contact__user">
                      <div className="dashboard__left__contact__user__icon">
                        <Image
                          className="dashboard__left__contact__user__icon-img"
                          name="personal-url.svg"
                          width={12}
                          height={12}
                        />
                      </div>
                      <span className="dashboard__left__contact__user-contact">
                        {candidates.personal_url}
                      </span>
                    </div>
                  )}
                </div>
                <div className="dashboard__left__social">
                  {socialMedia &&
                    socialMedia.map((item: ISocialMediaData) => (
                      <a href={item.url} key={item.id} target="blank">
                        <Image
                          key={item.id}
                          className="dashboard__left__social-icons"
                          width={31}
                          height={31}
                          name={`${item.network}.svg`}
                        />
                      </a>
                    ))}
                </div>
                <div className="dashboard__left__actions">
                  {candidateHasCV ? (
                    <div className="dashboard__left__actions-split">
                      <Button
                        onClick={handleViewCv}
                        t={t}
                        disableLoading
                        className="dashboard__left__actions-purple dashboard__left__actions-split__btn--left"
                        title={t('View CV')}
                      />
                      <span
                        className="dashboard__left__actions-split__divider"
                        aria-hidden="true"
                      />
                      <Button
                        isLoading={uploadLoading}
                        onClick={handleReUploadCv}
                        t={t}
                        className="dashboard__left__actions-purple dashboard__left__actions-split__btn--right"
                        title={t('Re-upload')}
                      />
                    </div>
                  ) : (
                    <Button
                      isLoading={uploadLoading}
                      onClick={handleReUploadCv}
                      t={t}
                      iconName="upload.svg"
                      className="dashboard__left__actions-purple"
                      title={t('Upload CV')}
                    />
                  )}

                  <Button
                    // disabled={uploadLoading || !candidate?.cv}
                    onClick={() => setShowDownload(true)}
                    t={t}
                    iconName="resume.svg"
                    className="dashboard__left__actions-sky"
                    title={t('Profile in PDF')}
                  />

                  {candidate?.report_urls?.feedback && (
                    <Button
                      t={t}
                      iconName="report.svg"
                      className="dashboard__left__actions-green"
                      onClick={() => {
                        if (candidate?.report_urls?.feedback) {
                          window.open(
                            candidate?.report_urls?.feedback,
                            'blank'
                          );
                        }
                      }}
                      title={t('Assessment Report')}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="dashboard__right">
              <div className="dashboard__right__top">
                <div className="dashboard__right__top__left">
                  <div className="dashboard_info_title">
                    <h1
                      className="dashboard__right__top__left-title"
                      onClick={handleOpenFreeUpgradePopup}
                    >
                      {t('invite friends')}
                    </h1>
                    {/* <div
                      onClick={() => setOpenModal(!openModal)}
                      className="info_image_container"
                    >
                      <Image className="info_image" name="attention.svg" />
                    </div> */}
                  </div>
                  {/* <p className="dashboard__right__top__left-desc">
                    {t('Upgrade or expand your account by inviting at least three of your friends to join you at recrout')}
                  </p> */}
                  <div className="dashboard__right__top__left__email">
                    <div className="inp">
                      <input
                        onInput={(e) =>
                          handleInviteInputChange(
                            (e.target as HTMLInputElement).value
                          )
                        }
                        className="dashboard__right__top__left__email-email"
                        type="email"
                        value={inviteEmail}
                        placeholder={t('email address')}
                      />
                      <Button
                        disabled={inviteEmail === '' || inviteEmailError !== ''}
                        t={t}
                        onClick={() => handleSendInvitataion()}
                        title="invite"
                        type="submit"
                        className={`dashboard__right__top__left__email-submit ${
                          inviteEmail === '' || inviteEmailError !== ''
                            ? 'deactive'
                            : ''
                        }`}
                      />
                    </div>
                    {inviteEmailError && (
                      <span className="error">{inviteEmailError}</span>
                    )}
                  </div>
                  <Link
                    className="dashboard__right__top__left__email-invitations"
                    to={'/invitations/'}
                  >
                    All invitations
                  </Link>
                </div>
                <div className="dashboard__right__top__right">
                  <Button
                    onClick={() => navigate(CANDIDATE_ROUTES.APPLICATIONS)}
                    t={t}
                    className="dashboard__right__top__right__button app"
                    title="My applications"
                  />

                  <Button
                    onClick={() => navigate(CANDIDATE_ROUTES.FIND_JOBS)}
                    t={t}
                    className="dashboard__right__top__right__button job"
                    title="Find job"
                    iconName="search.svg"
                  />
                </div>
              </div>
              <div className="dashboard__right__bottom">
                <div className="dashboard__right__bottom__tabs">
                  <div className="dashboard__right__bottom__tabs__header">
                    {tabHeader.map((item, index) => (
                      <div key={index}>
                        <div className="dashboard__right__bottom__tabs__header__item">
                          <span
                            onClick={() => handleTabChange(item)}
                            className={`dashboard__right__bottom__tabs__header__item-title ${
                              item.isActive ? 'active' : ''
                            }`}
                          >
                            {t(item.title)}
                            <span className="line"></span>
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="dashboard__right__bottom-tab">
                  {showSelectedTab()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAvatarPopup && (
        <Popup title={t('Edit Your Profile Image')} onClose={handleClosePopup}>
          <AvatarPopup
            id={me.candidate_id}
            t={t}
            onPopupClose={handleClosePopup}
          />
        </Popup>
      )}
      {showTeaserPopup && (
        <Popup
          className="view_as"
          title={t("This is the teaser that company get to see before they decide to contact you or accept your application. It's your first business card, keep that in mind when creating your profile!")}
          onClose={handleClosePopup}
        >
          <TeaserViewPopup />
        </Popup>
      )}

      {showFreeUpgradePopup && (
        <Popup title={t('free_upgrade')} onClose={handleCloseFreeUpdragePopup}>
          <FreeUpgradePopup />
        </Popup>
      )}

      {showDownload && (
        <Popup
          title={t('Download PDF')}
          description={t('Please select the file you would like to download')}
          onClose={() => setShowDownload(false)}
        >
          <DownloadPDFPopup setIsClose={() => setShowDownload(false)} />
        </Popup>
      )}

      {showCvSkillsPopup && cvUploadSkills && (
        <Popup
          title={t(
            'We found the following skills in your uploaded resume.'
          )}
          description={t('Please review, edit, and save them.')}
          className="expertise cv-skills-review-popup"
          onClose={handleCloseCvSkillsPopup}
          closeOnOverlayClick={!cvSkillsExtracting}
          showCloseButton={!cvSkillsExtracting}
        >
          <CvSkillsReviewPopup
            t={t}
            candidateId={me.candidate_id}
            isExtracting={cvSkillsExtracting}
            existingHardSkills={cvUploadSkills.existingHardSkills}
            existingSoftSkills={cvUploadSkills.existingSoftSkills}
            previewHardSkills={cvUploadSkills.previewHardSkills}
            previewSoftSkills={cvUploadSkills.previewSoftSkills}
            onClose={handleCloseCvSkillsPopup}
            onSaved={handleCvSkillsSaved}
          />
        </Popup>
      )}

      {showCvSkillsPopup && !cvUploadSkills && (
        <Popup
          title={t('Upload CV')}
          className="expertise cv-skills-review-popup cv-skills-review-popup--extracting"
          onClose={handleCloseCvSkillsPopup}
          closeOnOverlayClick={false}
          showCloseButton={false}
        >
          <CvSkillsReviewPopup
            t={t}
            candidateId={me.candidate_id}
            isExtracting={true}
            existingHardSkills={[]}
            existingSoftSkills={[]}
            previewHardSkills={[]}
            previewSoftSkills={[]}
            onClose={handleCloseCvSkillsPopup}
          />
        </Popup>
      )}

      <input
        className="invisible"
        onChange={handleInputChange}
        ref={uploadFile}
        type="file"
        accept=".pdf"
      />

      <Footer />
    </div>
  );
};

export default Dashboard;
